import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

// project-imports
import useAuth from 'hooks/useAuth';
import { ADMIN_ROLES } from 'utils/roles';
import { APP_DEFAULT_PATH } from 'config';

// ==============================|| ROLE GUARD ||============================== //
// Restricts a route to specific roles (default: admins). Non-matching users are
// sent to the app's default page. Waits for auth to initialise so it never
// redirects before the user is known.

const RoleGuard = ({ children, roles = ADMIN_ROLES }) => {
  const { isInitialized, isLoggedIn, user } = useAuth();

  if (!isInitialized) return null;
  if (isLoggedIn && user && roles.includes(user.role)) return children;
  return <Navigate to={APP_DEFAULT_PATH} replace />;
};

RoleGuard.propTypes = {
  children: PropTypes.node,
  roles: PropTypes.array,
};

export default RoleGuard;
